import Utils from './utils';

class Tabs {
  constructor(tabsElement) {
    this.tabs = tabsElement;
    this.enable = false;

    if (!this.enable) {
      return;
    }

    if (!this.tabs) {
      return;
    }

    this.classnames = {
      active: 'is-active',
    };

    this.selectors = {
      tabsNavLinks: '.js-km-awards-tabs-nav-link',
      tabsContentItems: '.js-km-awards-tabs-content-item',
    };

    this.navLink = null;
    this.tabId = null;

    this.tabsNavLinks = this.tabs.querySelectorAll(this.selectors.tabsNavLinks);
    this.tabsContentItems = this.tabs.querySelectorAll(this.selectors.tabsContentItems);

    this.tabsChangeHandler();
  }

  tabsChangeHandler() {
    this.tabsNavLinks.forEach((tabNavLink) => {
      tabNavLink.addEventListener('click', (e) => {
        e.preventDefault();

        this.tabId = tabNavLink.getAttribute('data-tab');
        this.navLink = tabNavLink;

        this.switchTabs();

        Utils.scrollTo(this.tabs);
      });
    });
  }

  switchTabs() {
    this.tabsNavLinks.forEach((tabNavLink) => {
      tabNavLink.classList.remove(this.classnames.active);
    });

    this.tabsContentItems.forEach((tabContentItem) => {
      tabContentItem.classList.remove(this.classnames.active);
    });

    this.navLink.classList.add(this.classnames.active);
    this.tabs
      .querySelector(`${this.selectors.tabsContentItems}#${this.tabId}`)
      .classList.add(this.classnames.active);
  }
}

export default Tabs;
